import axios from "axios";
import { del, get, post, patch,  put } from "./students_api_helper";
import * as url from "./students_url_helper";





// Get features
export const getStudents = (filters = {}) => get(url.GET_STUDENTS, { params: filters });

export const getStudentByUuid = (uuid) => get(`${url.GET_STUDENT_BY_UUID}/${uuid}`);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewStudent = student => post(url.ADD_NEW_STUDENT, student);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateStudent = student => patch(`${url.UPDATE_STUDENT}/${student.id}`,  student);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteStudent = student => del(`${url.DELETE_STUDENT}/${student.id}`);







export {
  //getLoggedInUser,
  
  
};
